import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  return (
    <section id="contact" className="py-24 md:py-32 relative bg-white">
      <div className="container mx-auto px-6 max-w-6xl">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="bg-slate-50 rounded-[2.5rem] p-8 md:p-16 relative overflow-hidden border border-slate-100 shadow-sm"
        >
          {/* Decorative background shape */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-gradient-to-br from-indigo-100 to-purple-100 rounded-full blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3"></div>
          
          <div className="relative z-10 grid lg:grid-cols-2 gap-16 lg:gap-24">
            
            <div>
              <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-6 font-sans tracking-tight">Let's Build Something Together</h2>
              <p className="text-lg text-slate-600 mb-10 leading-relaxed">
                Have a business inquiry, partnership proposal, or just want to say hi? We'd love to hear from you.
              </p>

              <div className="space-y-8">
                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-slate-200 flex items-center justify-center flex-shrink-0">
                    <SafeIcon name="Mail" className="text-indigo-600 text-xl" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-1">Email Us</div>
                    <a href="mailto:hello@digitalways.in" className="text-lg font-medium text-slate-900 hover:text-indigo-600 transition-colors">hello@digitalways.in</a>
                  </div>
                </div>

                <div className="flex items-start gap-5">
                  <div className="w-12 h-12 rounded-2xl bg-white shadow-sm border border-slate-200 flex items-center justify-center flex-shrink-0">
                    <SafeIcon name="MapPin" className="text-indigo-600 text-xl" />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-2">Location</div>
                    <div className="text-lg font-medium text-slate-900 whitespace-pre-line leading-relaxed">
                      {`Digital Ways\n430, Orbit Plaza\nCrossings Republik\nGhaziabad 201016, UP, India`}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-3xl p-8 shadow-xl shadow-slate-200/50 border border-slate-100">
              <form 
                action="mailto:hello@digitalways.in" 
                method="POST" 
                encType="text/plain"
                className="space-y-5"
              >
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-slate-700">First Name</label>
                    <input 
                      name="First Name"
                      type="text" 
                      required
                      className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-slate-900 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all" 
                      placeholder="John" 
                    />
                  </div>
                  <div className="space-y-2">
                    <label className="text-sm font-semibold text-slate-700">Last Name</label>
                    <input 
                      name="Last Name"
                      type="text" 
                      required
                      className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-slate-900 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all" 
                      placeholder="Doe" 
                    />
                  </div>
                </div>
                
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-slate-700">Email Address</label>
                  <input 
                    name="Email"
                    type="email" 
                    required
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-slate-900 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all" 
                    placeholder="john@company.com" 
                  />
                </div>
                
                <div className="space-y-2">
                  <label className="text-sm font-semibold text-slate-700">Message</label>
                  <textarea 
                    name="Message"
                    rows="4" 
                    required
                    className="w-full bg-slate-50 border border-slate-200 rounded-xl px-4 py-3.5 text-slate-900 focus:outline-none focus:border-indigo-500 focus:ring-2 focus:ring-indigo-100 transition-all resize-none" 
                    placeholder="How can we help you?"
                  ></textarea>
                </div>
                
                <button type="submit" className="w-full py-4 bg-slate-900 text-white font-bold rounded-xl hover:bg-indigo-600 transition-colors mt-2 shadow-md">
                  Send Message
                </button>
              </form>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;